import { Flex, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"

const { Text } = Typography

const SuggestionsLoader = () => {
  const { t } = useTranslation()

  return (
    <Flex gap={8} align="center">
      <Spin size="small" />
      <Text type="secondary">{t("Loading suggestions from your payment provider…")}</Text>
    </Flex>
  )
}

export default SuggestionsLoader
